// AGZDModal.tsx
import React, { useContext, useEffect, useState } from "react";
import * as S from "./styles"; // Import all styled components
import ImageContainer from "@components/imageContainer";
import { Context } from "@components/useContext/context";
import { connect } from "react-redux";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { resolvePath } from "@utils/resolvePath";
import DOMPurify from "isomorphic-dompurify";

interface ServiceCenter {
  id: number;
  name: string;
  rating: number | string;
  reviews: string;
  location: string;
  distance: number;
}

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const formatGarageCount = (count: number): number => {
  if (count < 10) {
    return count; 
  } else if (count < 25) {
    return 10; 
  } else if (count < 50) {
    return 25;
  } else if (count >= 1000) {
    return 1000; 
  } else {
    return Math.floor(count / 50) * 50;
  }
};

const AckoGarageUpGradeModalContent = (props: any) => {
  const {
    actions,
    is_visible,
    eligiblePlanData,
    garageCount,
    lat,
    lng,
    garageList,
    headerTitle,
    infoBannerText,
    exploreLinkText,
    warningText
  } = props;
  let car_zero_depreciation_deductible_plus_price = 0;
  let zero_dep_deductible_price = 0;
  const { isDesktop } = useContext(Context);
  eligiblePlanData?.forEach((eachPlan: any) => {
    eachPlan.id === "car_zero_depreciation_deductible_plus" &&
      (car_zero_depreciation_deductible_plus_price =
        eachPlan.price.net_premium);
    eachPlan.id === "zero_dep_deductible" &&
      (zero_dep_deductible_price = eachPlan.price.net_premium);
  });
  const { on_close_click, on_explore_click } = actions || {};
  const [serviceCenters, setServiceCenters] = useState<ServiceCenter[]>([]);

  useEffect(() => {
    const garage_list = garageList?.map((eachGarage: any) => {
      return {
        id: eachGarage?.id,
        name: eachGarage?.name,
        rating: eachGarage?.metadata?.rating || 4.5,
        location: eachGarage?.metadata?.address,
        distance: eachGarage?.distance
      };
    });
    setServiceCenters(garage_list);
  }, [garageList]);

  const priceDifference =
    car_zero_depreciation_deductible_plus_price - zero_dep_deductible_price;
  return (
    <>
      {" "}
      <S.ModalWrapper>
        <S.TopImageWrapper>
          <ImageContainer
            imgSrc={resolvePath("/images/close_cross.svg")}
            alt="recommend_plan"
            width={24}
            height={24}
            styles={{ paddingTop: "10px" }}
            onClick={() => {
              if (on_close_click?.length > 0) {
                on_close_click?.forEach((eachFunc: any) => {
                  typeof eachFunc.funCall === "function" &&
                    eachFunc.funCall(
                      //@ts-ignore
                      {
                        ...eachFunc.args
                      } || {}
                    );
                });
              }
            }}
          />
        </S.TopImageWrapper>
        {isDesktop ? (
          <S.MainTitleWrapper>
            {headerTitle && <S.RegularText>{headerTitle}</S.RegularText>}{" "}
            <div>
              <S.GradientText>
                Upgrade for just ₹{priceDifference}
              </S.GradientText>
            </div>
          </S.MainTitleWrapper>
        ) : (
          <>{headerTitle && <S.MainTitle>{headerTitle}</S.MainTitle>}</>
        )}
        <S.ContentCard>
          {!isDesktop && (
            <S.HighlightSubtitle>
              Upgrade for just ₹{priceDifference}
            </S.HighlightSubtitle>
          )}

          {infoBannerText && (
            <S.InfoBanner>
              <S.InfoBannerText
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(infoBannerText)
                }}
              />
            </S.InfoBanner>
          )}

          {!isDesktop && <S.ServiceCenterSeparator />}

          <S.BenefitsList>
            <S.BenefitItem>
              <ImageContainer
                imgSrc={resolvePath("/images/claimdeduction.svg")}
                alt="claimdeduction"
                width={18}
                height={18}
              />
              <S.BenefitText>
                No <span>₹5,000 deductible</span>
              </S.BenefitText>
            </S.BenefitItem>
            <S.BenefitItem>
              <ImageContainer
                imgSrc={resolvePath("/images/garage.svg")}
                alt="garage"
                width={18}
                height={18}
              />
              <S.BenefitText>
                Repairs at{" "}
                <span>
                  {" "}
                  {formatGarageCount(garageCount)}+ ACKO network garages{" "}
                </span>
              </S.BenefitText>
            </S.BenefitItem>
          </S.BenefitsList>
          {isDesktop && <S.ServiceCenterSeparator />}
          <div>
            <S.ServiceCenterScroller>
              <S.ServiceCenterList>
                {serviceCenters.map((serviceCenter) => (
                  <S.ServiceCenterCardWrapper key={serviceCenter.id}>
                    <S.ServiceCenterInfo>
                      <S.ServiceCenterTitle>
                        {serviceCenter.name}
                      </S.ServiceCenterTitle>
                      <S.ServiceCenterSubText>
                        <ImageContainer
                          imgSrc={resolvePath("/images/full_star.svg")}
                          alt="rating"
                          width={12}
                          height={12}
                        />
                        &nbsp;{serviceCenter.rating} | {serviceCenter.distance}{" "}
                        km away
                      </S.ServiceCenterSubText>

                      <S.ServiceCenterLocationText>
                        {serviceCenter.location}
                      </S.ServiceCenterLocationText>
                    </S.ServiceCenterInfo>
                  </S.ServiceCenterCardWrapper>
                ))}
              </S.ServiceCenterList>
            </S.ServiceCenterScroller>
            <S.ExploreLink
              onClick={() => {
                if (on_explore_click?.length > 0) {
                  on_explore_click?.forEach((eachFunc: any) => {
                    typeof eachFunc.funCall === "function" &&
                      eachFunc.funCall({ ...eachFunc.args });
                  });
                }
              }}
            >
              {exploreLinkText}
            </S.ExploreLink>
          </div>
        </S.ContentCard>
      </S.ModalWrapper>
      <S.WarningBox>
        <ImageContainer
          imgSrc={resolvePath("/images/handcoin.svg")}
          alt="handcoin"
          width={52}
          height={52}
        />
        <S.WarningText
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(warningText)
          }}
        />
      </S.WarningBox>
    </>
  );
};

export default connect(mapStateToProps)(AckoGarageUpGradeModalContent);
